import type { FaireProductEntity } from "../../entity_types/product";

export const p_sfguejsrs5: FaireProductEntity = {
  token: "p_sfguejsrs5",
  type: "product",
  name: "Sticker Book Issue #7",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/7e35514f707ea97c7b4876bcbc9ac3ab04dd6b377e4a84d223005748e39fad10.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8177176fb3e7ae0b39ab2a016a7a2484f20cf5717337ccef8da2435e82d623cc.jpeg",
    "https://cdn.faire.com/fastly/0e5dcd366b24bf326fe5a43711d1bbc677b5db26b14d2b7e0ade73b6e0cfd485.jpeg",
    "https://cdn.faire.com/fastly/5c8622480cc6760075f7e08ba04e710a6fef5e47b995534aad60d18a3096c79a.jpeg"
  ],
  priceDollars: 6.5,
  description: "It wouldn’t be a planner release without a new sticker book—and this one is really, really, really good. Inside, you’ll find 35 pages with over 700 stickers, featuring everything from important reminders to cute dogs to words of encouragement. Whether you’re decorating your planner, journaling, or just adding a little extra joy to your notes, these stickers make organizing way more fun.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• 35 pages filled with 700+ colorful stickers\n• Includes reminders, icons, affirmations, and playful designs\n• Perfect for planners, notebooks, scrapbooks, or cards\n• Compact, portable, and easy to take on the go\n• Designed in Bando’s signature bright, positive aesthetic\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n\n• Gift shops and stationery boutiques\n• Bookstores, office supply retailers, and planner enthusiasts\n• Back-to-school or creative craft collections\n• Wholesale buyers seeking fun, functional stationery accessories",
  tags: [],
  msrpDollars: 13.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:40.821Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
